
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class IssueMaterialItemsGrid extends Serenity.EntityGrid<IssueMaterialItemsRow, any> {
        protected getColumnsKey() { return 'Production.IssueMaterialItems'; }
        protected getDialogType() { return IssueMaterialItemsDialog; }
        protected getIdProperty() { return IssueMaterialItemsRow.idProperty; }
        protected getInsertPermission() { return IssueMaterialItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return IssueMaterialItemsRow.localTextPrefix; }
        protected getService() { return IssueMaterialItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}